import { render, staticRenderFns } from "./InfoPopUp.vue?vue&type=template&id=5ebaaba9&"
import script from "./InfoPopUp.vue?vue&type=script&lang=js&"
export * from "./InfoPopUp.vue?vue&type=script&lang=js&"
import style0 from "./InfoPopUp.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/tempos21/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('5ebaaba9', component.options)
    } else {
      api.reload('5ebaaba9', component.options)
    }
    module.hot.accept("./InfoPopUp.vue?vue&type=template&id=5ebaaba9&", function () {
      api.rerender('5ebaaba9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Layout/InfoPopUp.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/Layout/InfoPopUp.vue
// module id = r62y
// module chunks = 0